// src/pages/ValoriAziendali.jsx
import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { fetchBlog } from "../utilis/apiService";
import Navbar from "../sections/Navbar";

const ValoriAziendali = () => {
  const { slug } = useParams();
  const baseUrl = process.env.REACT_APP_API_URL;  
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState(null);

  useEffect(() => {
    fetchBlog(slug)
      .then((data) => setArticle(data))
      .catch(() => setError("Impossibile caricare l'articolo"))
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) return <div className="text-center my-5">Caricamento…</div>;
  if (error)   return <div className="text-center text-danger my-5">{error}</div>;
  if (!article) return null;

  // Preparo un array di un solo elemento per il Navbar
  const headerContent = [{
    // Navbar si aspetta queste proprietà:
    titolo_1:       article.titolo_1,       // se non esistono, Navbar userà titolo_it
    titolo_2:       article.titolo_2,
    immagine_url:   baseUrl +  '/contenuti/' + article.ID + '/' + article.immagine,
    descrizione_it: '',
    link_it:        article.link_it,
    call_to_action_it: article.call_to_action_it,
    titolo_it:      article.titolo_it,
  }];

  console.log(headerContent);

  return (
    <>
      {/* 1) Navbar con soli titolo+immagine */}
      <Navbar
        contenuti={headerContent}
        breadCrumbs={"Home > News ed eventi"}
      />

      {/* 2) Corpo dell’articolo */}
      <div className="container my-5">
        {article.immagine_url && (
          <img
            src={article.immagine_url}
            alt={article.titolo_it}
            className="img-fluid mb-4"
          />
        )}
        <div dangerouslySetInnerHTML={{ __html: article.descrizione_it }} />
        <div style={{ marginBottom: 80,  fontWeight: "bold"}}>
          <Link
            to="/news-ed-eventi"
            style={{
              color: "#727697",        
              textDecoration: "none" 
            }}
          >
            ← Torna al Blog
          </Link>
        </div>
      </div>
    </>
  );
};

export default ValoriAziendali;
